import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { EllipsisDropdownItem } from "@similarweb/ui-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const DropdownTitle = styled.p`
    margin: 0 0 0 17px;
    ${setFontVariant("listSectionTitle", colorsPalettes.carbon[500])};
    line-height: 4;
`;

export const DropdownItem = styled(EllipsisDropdownItem)`
    display: flex;
    justify-content: space-between;

    & > div:first-of-type {
        width: 100%;

        & > div:nth-child(2) {
            width: 100%;
        }
    }
`;

export const DropdownItemLayout = styled(FlexRow)`
    justify-content: space-between;
`;
